import styled from 'styled-components';
export const StyledSectionHeader = styled.header `
  padding: 23px 0 18px;
`;
//# sourceMappingURL=SectionHeader.styles.js.map